import wrapWithProvider from "./wrapWithProvider"
export const wrapRootElement = wrapWithProvider
